import { AddressModel } from '@steelbuy/ts-shared';

import { createCollectionDataContext } from '../../util/provider/CollectionDataProvider';

export const WarehouseAddressCollectionData = createCollectionDataContext<AddressModel>();
